import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { BillingSubscription, BillingInvoice, OneTimeFee } from '@/types/billing'


interface billingsInitialState {
  /** undefined = not yet loaded; null = no subscription (404); BillingSubscription = loaded */
  subscription?: BillingSubscription | null
  invoices?: BillingInvoice[]
  oneTimeFees?: OneTimeFee[]
}

const initialState: billingsInitialState = {
  subscription: undefined,
  invoices: [],
  oneTimeFees: []
}

const setSubscription = (
  state: billingsInitialState = initialState,
  action: PayloadAction<BillingSubscription | null>
) => {
  return {
    ...state,
    subscription: action.payload
  }
}

const setInvoices = (
  state: billingsInitialState = initialState,
  action: PayloadAction<BillingInvoice[]>
) => {
  return {
    ...state,
    invoices: action.payload
  }
}

const setOneTimeFees = (
  state: billingsInitialState = initialState,
  action: PayloadAction<OneTimeFee[]>
) => {
  return {
    ...state,
    oneTimeFees: action.payload
  }
}

const clearBilling = () => initialState

const resetSubscription = (state: billingsInitialState = initialState) => ({
  ...state,
  subscription: undefined,
})

const billingSlice = createSlice({
  name: 'billing',
  initialState,
  reducers: {
    setSubscription,
    setInvoices,
    setOneTimeFees,
    clearBilling,
    resetSubscription
  }
})

export const billingReducer = billingSlice.reducer
export const billingActions = billingSlice.actions
